//------------------------------------------------------ externos
import { useEffect, useState } from "react";
//------------------------------------------------------ elementos
import FormContent from "../../funcionales/FormContent";
import MarcoModal from "../../funcionales/MarcoModal";
import FormPasos from "../../funcionales/FormPasos";
import FormHeader from "../../funcionales/FormHeader";
import TextButton from "../../buttons/TextButton";
import Loading from "../../../routes/Loading";
//------------------------------------------------------ funciones
import { cargarSelects } from "../../../functions/dataFunctions";
import { submitMovimientoPorteria } from "../data/Submits";
import { eventos } from "../data/FormContent";
//------------------------------------------------------ estilos
import "../css/Forms.css";

const FormMovimientoPorteria = ({
  elemento = null,
  type = "porteria",
  onGuardar,
  onClose,
}) => {
  const campos = eventos[type];
  const titulo = "Porteria";
  const subtitulo = "Ingresos y salidas del predio";

  // Paso a paso por defecto: esto se carga en el porton, con el celular en
  // una mano. La vista completa sigue estando a un toque para quien lo carga
  // sentado, o para corregir un evento viejo.
  const [porPasos, setPorPasos] = useState(!elemento);
  const [loading, setLoading] = useState(true);
  const [listas, setListas] = useState({});
  const [formData, setFormData] = useState({
    area: "porteria",
    tipo: elemento?.tipo || null,
    operador: elemento?.operador || null,
    persona: elemento?.persona || null,
    tractor: elemento?.tractor || null,
    furgon: elemento?.furgon || null,
    // Un evento nuevo arranca SIN contestar (`null`), no en «vacío». Con
    // `false` de entrada el paso opcional figuraba como contestado: el botón
    // decía «Siguiente» en vez de «Omitir» y el resumen listaba «Con carga»
    // aunque nadie lo hubiera tocado. Al guardar, sin contestar sigue siendo
    // `false` (lo pone `submitMovimientoPorteria`), igual que antes.
    cargado: elemento?.cargado ?? null,
    detalle: elemento?.detalle || "",
    chequeos: elemento?.chequeos || [],
  });

  useEffect(() => {
    const cargarDatos = async () => {
      const data = await cargarSelects();
      setListas(data);
      setLoading(false);
    };

    cargarDatos();
  }, []);

  const handleSubmit = async (e) => {
    if (e?.preventDefault) e.preventDefault();

    await submitMovimientoPorteria(
      elemento,
      formData,
      campos,
      setLoading,
      onGuardar,
      onClose,
    );
  };

  return (
    <MarcoModal onClose={onClose}>
      {loading ? (
        <Loading />
      ) : (
        <div className="doble-form">
          <div className="doble-form-content">
            <FormHeader title={titulo} subTitle={subtitulo} onClose={onClose} />
            {porPasos ? (
              <FormPasos
                elemento={elemento}
                campos={campos}
                opciones={listas}
                data={formData}
                setData={setFormData}
                onGuardar={handleSubmit}
                onVerCompleto={() => setPorPasos(false)}
              />
            ) : (
              <>
                <div className="doble-form-modal">
                  <FormContent
                    elemento={elemento}
                    campos={campos}
                    opciones={listas}
                    data={formData}
                    setData={setFormData}
                    isDouble={true}
                  />
                </div>
                <div className="form-buttons">
                  <TextButton
                    text={"Guardar"}
                    type={"button"}
                    onClick={handleSubmit}
                  />
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </MarcoModal>
  );
};

export default FormMovimientoPorteria;
